import { Directive, Input } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: '[plrConnectForm]'
})
export class ConnectFormDirective {
  @Input('plrConnectForm')
  set data(val: any) {
    if (val) {
      this.formGroupDirective.form.patchValue(val);
      this.formGroupDirective.form.markAsPristine();
    }
  }
  constructor(private formGroupDirective: FormGroupDirective) { }
}



// WEBPACK FOOTER //
// ./src/app/pillar/common/directives/connect-form.directive.ts